import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { colors } from '@/styles'

const BottomContainer = styled.div`
  margin-top: 32px;
  padding: 0 15px;
  width: 100%;
`

const LogInButton = styled.button`
  background-color: #132b3e;
  box-shadow: 0px 2px 4px rgba(19, 43, 62, 0.25),
    0px 6px 6px 2px rgba(19, 43, 62, 0.1);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: ${colors.white};
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.2px;
  line-height: 16px;
  margin: 0 0 8px;
  padding: 15px 10px;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
`

const SignupButton = styled.button`
  background-color: ${colors.white};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border: 1.5px solid ${colors.grey88};
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.2px;
  line-height: 16px;
  margin: 0;
  padding: 15px 10px;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
`

const SidebarBottomContainerMobile = ({ loginClick, signupClick }) => {
  const { t } = useTranslation()

  return (
    <BottomContainer>
      <LogInButton onClick={loginClick} id="menu-account-login">
        {t('common.login', 'Log in')}
      </LogInButton>
      <SignupButton onClick={signupClick} id="menu-account-signup">
        {t('common.sign_up', 'Sign up')}
      </SignupButton>
    </BottomContainer>
  )
}

export default SidebarBottomContainerMobile
